import './App.css';
import ShiftDetails from './components/ShiftDetails';
import MainCategories from './components/MainCategories';
import GeneralProcess from './components/GeneralProcess';
import LiveClock from './components/LiveClock';
import ManualEnter from './components/ManualEnter';
import JobOperation from './components/JobOperation';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import JobProcessSelection from './components/JobProcessSelection';
import PlanDashbord from './components/PlanDashbord';
import LoginForm from './components/LoginForm';
import AdminDashboard from './components/AdminDashboard';
import ManhourShiftEnter from './components/ManhourShiftEnter';
import SupervisorMainPage from './components/SupervisorMainPage';
import MachineSupervisorPage from './components/MachineSupervisorPage'; // ✅ NEW
import { MachineSupervisorProvider } from './components/MachineSupervisorContext'; // ✅ NEW

import { UserProvider } from './components/UserContext';
import { MachineProvider } from './components/context/MachineContext';
import HrDashbord from './components/HrDashbord';
import { EmployeeProvider } from './components/EmployeeContext';

import { ThemeProvider } from './theme/ThemeContext';
import MuiBridge from './theme/MuiBridge';

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <MuiBridge>
          <UserProvider>
            <EmployeeProvider>
              <MachineProvider>
                {/* ✅ NEW: Machine Supervisor Provider */}
                <MachineSupervisorProvider>
                  <LiveClock />

                  <Router>
                    <Routes>
                      <Route path="/" element={<LoginForm />} />
                      <Route path="/AdminDashboard" element={<AdminDashboard/>} />
                      <Route path="/PlanDashbord" element={<PlanDashbord/>} />
                      <Route path="/HrDashbord" element={<HrDashbord/>} />
                      <Route path="/ManhourShiftEnter" element={<ManhourShiftEnter />} />
                      <Route path="/SupervisorMainPage" element={<SupervisorMainPage />} />
                      <Route path="/ShiftDetails" element={<ShiftDetails />} />
                      <Route path="/MainCategories" element={<MainCategories />} />
                      <Route path="/GeneralProcess" element={<GeneralProcess />} />
                      <Route path="/JobProcessSelection" element={<JobProcessSelection />} />
                      <Route path="/ManualEnter" element={<ManualEnter />} />
                      <Route path="/JobOperation" element={<JobOperation />} />
                      <Route path='/MachineSupervisorPage' element={<MachineSupervisorPage/>}/>
                    </Routes>
                  </Router>
                </MachineSupervisorProvider>
                {/* ✅ END: Machine Supervisor Provider */}
              </MachineProvider>
            </EmployeeProvider>
          </UserProvider>
        </MuiBridge>
      </ThemeProvider>
    </div>
  );
}

export default App;